import { BaseEntity } from './base-raptor-models';
import { Inspection } from './inspection.model';
import { Quote } from './quote.model';
import { User } from './user.model';
import { Vehicle } from './vehicle.model';

export interface TimeClock extends BaseEntity {
    userId: string;
    type: TimeClockType;
    eventType: TimeClockEventType;
    date: Date;
    referenceId?: string;
    reference?: TimeClock;
    durationInHours?: number;
    user?: User;
    inspectionId?: string;
    inspection?: Inspection;
    jobId?: string;
    workOrderId?: string;
    //WorkOrder?: WorkOrder; TODO: add WorkOrder model
    // resolved references
    vehicle?: Vehicle;
    quote?: Quote;
}

/**
 * The single open job clock-in a technician may hold, named well enough to show them. Returned by
 * `GET timeclock/open-job-clock`; null from that endpoint means no job clock is open.
 *
 * The job's container is carried as the mutually exclusive `targetQuoteId` / `targetWorkOrderId` pair
 * used across the application, with `targetNumber` holding whichever container's number. All three are
 * absent when the job sits under neither.
 */
export interface OpenJobClock extends BaseEntity {
    jobId: string;
    jobName: string;
    targetQuoteId?: string;
    targetWorkOrderId?: string;
    targetNumber?: string;
    clockedInSince: Date;
}

export enum TimeClockType {
    ClockIn = 'ClockIn',
    ClockOut = 'ClockOut',
}

export enum TimeClockEventType {
    WorkDay = 'WorkDay',
    Inspection = 'Inspection',
    WorkOrder = 'WorkOrder',
    Job = 'Job',
}
